<mat-card style="padding: 0px">
  <mat-toolbar style="background-color: lightgray">
    <h2 mat-line style="margin-top:10px">{{ 'contactesTreball.titol' | translate }}</h2>
    <button style="margin-left: auto; margin-right: 0" mat-icon-button (click)="openEditor()" matTooltip="{{ 'contactesTreball.afegirToolTip' | translate }}" attr.aria-label="{{ 'contactesTreball.afegirToolTip' | translate }}" matTooltipClass="tooltip-style">
      <mat-icon>person_add</mat-icon>
    </button>
  </mat-toolbar>
  <mat-card-content>
      <div *ngIf="!contactsFormGroups || !contactsFormGroups.length">
        {{ 'contactesTreball.senseContactes' | translate }}
      </div>
      <div *ngFor="let contactForm of contactsFormGroups;">
        <form [formGroup]="contactForm">
          <mat-form-field>
           <input matInput placeholder="{{ 'contactesTreball.camps.tipus' | translate }}" name="tipus"
            [formControlName]="'tipus'"
           />
          </mat-form-field> 
          <mat-form-field>
            <input matInput placeholder="{{ 'contactesTreball.camps.nom' | translate }}" name="nom"
            [formControlName]="'nom'"
            />
          </mat-form-field>
          <mat-form-field>
           <input matInput placeholder="{{ 'contactesTreball.camps.correu' | translate }}" name="email" type="email"
            [formControlName]="'email'"
           />
          </mat-form-field>
          <mat-form-field>
           <input matInput placeholder="{{ 'contactesTreball.camps.telefon' | translate }}" name="tlf" type="phone"
            [formControlName]="'tlf'"
           />
          </mat-form-field> 
          <mat-form-field>
            <input matInput placeholder="{{ 'contactesTreball.camps.mobil' | translate }}" name="mobil" type="phone"
            [formControlName]="'mobil'"
            />
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="{{ 'contactesTreball.camps.linkedin' | translate }}" name="linkedin"
            [formControlName]="'linkedin'"
            />
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="{{ 'contactesTreball.camps.adreca' | translate }}" name="adreca"
            [formControlName]="'adreca'"
            />
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="{{ 'contactesTreball.camps.comentari' | translate }}" name="comentari"
            [formControlName]="'comentari'"
            />
          </mat-form-field>
        </form>
        <button style="margin-left: auto; margin-right: 0" mat-icon-button (click)="updateContact('UPDATE', contactForm)">
          <mat-icon>save</mat-icon>
        </button>
        <button style="margin-right: 0" mat-icon-button (click)="updateContact('REMOVE', contactForm)">
          <mat-icon>remove</mat-icon>
        </button>
      </div>
      <div *ngIf="showEditor">
        <form>
          <mat-form-field>
           <input matInput placeholder="{{ 'contactesTreball.camps.tipus' | translate }}" name="tipus"
            [(ngModel)]="newContactData.type" ngDefaultControl
           />
          </mat-form-field>
          <mat-form-field>
           <input matInput placeholder="{{ 'contactesTreball.camps.nom' | translate }}" name="nom"
            [(ngModel)]="newContactData.nom" ngDefaultControl
           />
          </mat-form-field>
          <mat-form-field>
           <input matInput placeholder="{{ 'contactesTreball.camps.correu' | translate }}" name="email" type="email"
            [(ngModel)]="newContactData.email" ngDefaultControl
           />
          </mat-form-field> 
          <mat-form-field>
           <input matInput placeholder="{{ 'contactesTreball.camps.telefon' | translate }}" name="tlf" type="phone"
            [(ngModel)]="newContactData.tlf" ngDefaultControl
           />
          </mat-form-field> 
          <mat-form-field>
            <input matInput placeholder="{{ 'contactesTreball.camps.mobil' | translate }}" name="mobil" type="phone"
            [(ngModel)]="newContactData.mobil" ngDefaultControl
            />
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="{{ 'contactesTreball.camps.linkedin' | translate }}" name="linkedin"
            [(ngModel)]="newContactData.linkedin" ngDefaultControl
            />
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="{{ 'contactesTreball.camps.comentari' | translate }}" name="comentari"
            [(ngModel)]="newContactData.comentari" ngDefaultControl
            />
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="{{ 'contactesTreball.camps.adreca' | translate }}" name="adreca"
            [(ngModel)]="newContactData.adreca" ngDefaultControl
            />
          </mat-form-field>
        </form>
        <button style="margin-left: auto; margin-right: 0" mat-icon-button (click)="addContact()" matTooltip="{{ 'contactesTreball.afegirToolTip' | translate }}" attr.aria-label="{{ 'contactesTreball.afegirToolTip' | translate }}" matTooltipClass="tooltip-style">
          <mat-icon>add</mat-icon>
        </button>
        <button style="margin-right: 0" mat-icon-button (click)="closeEditor()" matTooltip="{{ 'contactesTreball.esborrarToolTip' | translate }}" attr.aria-label="{{ 'contactesTreball.esborrarToolTip' | translate }}" matTooltipClass="tooltip-style">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
  </mat-card-content>
</mat-card>
